import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import BASE_URL from '../../../config/config';
import './css/admin_style.css';
import AdminTicketStats from './AdminTicketStats';

const AdminPrePanel = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [longitudUsuarios, setLongitudUsuarios] = useState(0);
  const [totalTickets, setTotalTickets] = useState(0);
  const [totalProyectos, setTotalProyectos] = useState(0);
  const [userRole, setUserRole] = useState('');
  const [userName, setUserName] = useState('');
  const token = localStorage.getItem('AuthToken');

  const handleLinkClick = () => {
    window.scrollTo({ top: 0});
  };

  useEffect(() => {
    const token = localStorage.getItem('AuthToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserRole(decoded.role);
        setUserName(decoded.nombre || '');
      } catch (error) {
        console.error('Error al decodificar el token:', error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/todos-usuarios-conteo`);
        const usuarios = response.data.total || 0;
        setUsuarios(usuarios);
        setLongitudUsuarios(usuarios);
      } catch (error) {
        console.error('Error al obtener los usuarios:', error);
      }
    };


    const fetchTotalTickets = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/tickets/total-conteo`, {
          headers: { Authorization: token }
        });
        const tickets = response.data.total || 0;
        setTotalTickets(tickets);
      } catch (error) {
        console.error('Error al obtener los tickets:', error);
      }
    };

    const fetchTotalProyectos = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/proyectos`);
        const proyectos = response.data.proyectos.length || 0;
        setTotalProyectos(proyectos);
      } catch (error) {
        console.error('Error al obtener los proyectos:', error);
      }
    };

    fetchUsuarios();
    fetchTotalTickets();
    fetchTotalProyectos();
  }, []);


  return (
    <div className="admin-prepanel-grid">
      <div className="intro-admin-prepanel">
        <h3>{userRole === 'admin' ? `Bienvenido, ${userName}` : userRole === 'tecnico' ? `Bienvenido, ${userName}` : `Hola, ${userName}`}</h3>
        <p>
          {userRole === 'admin'
            ? 'Accede rápido a la gestión de tickets, usuarios y ajustes del sistema.'
            : userRole === 'tecnico'
              ? 'Revisa aquí tus tickets asignados y gestiona tus tareas.'
              : 'Utiliza los accesos rápidos para ver tus servicios y tickets.'}
        </p>
      </div>
      <div className="titulo-seccion-panel">
        <p>Estadísticas generales </p>
      </div>
      {/* Estadísticas generales: sólo administradores/técnicos (componente protegido en backend) */}
      <AdminTicketStats />

      <div className="admin-prepanel-column">
        <div className="titulo-seccion-panel">
          <p>Accesos rápidos</p>
        </div>
        <div className='admin-prepanel'>
          <Link to={'/dashboard/tickets'} className='prepanel-card prepanel-tickets' onClick={handleLinkClick}>
            <div className="cabecera-prepanel-card">
              <img src="/images/billete.svg" alt="Ticket" className='dash-icon-tickets'/>
              <h3>Gestionar Tickets</h3>
            </div>
              <p className='prepanel-resume'>Responde y administra tickets por tu departamento.</p>

              <div className="info-prepanel-card">
                <div className='prepanel-data'>
                  <p>{totalTickets}</p>
                  <p>Incidencias abiertas</p>
                </div>
                <div className="prepanel-estado">
                  <p>Activo</p>
                </div>
              </div>
              <button>Ir al panel</button>
          </Link>

          {(userRole === 'admin' || userRole === 'tecnico') && (
            <Link to={'/dashboard/users'} className='prepanel-card prepanel-usuarios' onClick={handleLinkClick}>
              <div className="cabecera-prepanel-card">
                <img src="/images/usuarios-alt.svg" alt="Usuarios" className='dash-icon-users'/>
                <h3>Gestionar Usuarios</h3>
              </div>
              <p className='prepanel-resume'>Administra y verifica los usuarios de la plataforma.</p>

              <div className="info-prepanel-card">
                <div className='prepanel-data'>
                  <p>{longitudUsuarios}</p>
                  <p>Usuarios registrados</p>
                </div>
                <div className="prepanel-estado">
                  <p>Activo</p>
                </div>
              </div>
              <button>Ir al panel</button>
            </Link>
          )}

          {userRole === 'admin' && (
            <Link to={'/dashboard/tracking-proyectos'} className='prepanel-card prepanel-proyectos' onClick={handleLinkClick}>
              <div className="cabecera-prepanel-card">
                <img src="/images/carpeta-abierta.svg" alt="Proyectos" className='dash-icon-proyectos'/>
                <h3>Tracking de Proyectos</h3>
              </div>
              <p className='prepanel-resume'>Informa al cliente de las fases de realización de su proyecto.</p>

              <div className="info-prepanel-card">
                <div className='prepanel-data'>
                  <p>{totalProyectos}</p>
                  <p>Proyectos activos</p>
                </div>
                <div className="prepanel-estado">
                  <p>Activo</p>
                </div>
              </div>
              <button>Ir al panel</button>
            </Link>
          )}
        </div>
      </div>

    {/* Los accesos a equipos, ajustes y notificaciones se muestran ahora en el Dashboard dentro de .bloque-secciones */}
    </div>
  );
};

export default AdminPrePanel;
